import PoolsApi from '../api/pools'
import RestaurantsApi from '../api/restaurants'
import { addInfoNotification, addWarnNotification, addErrorNotification } from './notifications'

export const LOAD_POOL_RESTAURANTS_REQUESTED = 'poolRestaurants/LOAD_POOL_RESTAURANTS_REQUESTED'
export const LOAD_POOL_RESTAURANTS = 'poolRestaurants/LOAD_POOL_RESTAURANTS'
export const LOAD_POOL_RESTAURANTS_ERROR = 'poolRestaurants/LOAD_POOL_RESTAURANTS_ERROR'

export const REMOVE_RESTAURANT_FROM_POOL = 'poolRestaurants/REMOVE_RESTAURANT_FROM_POOL'
export const ADD_RESTAURANT_TO_POOL = 'poolRestaurants/ADD_RESTAURANT_TO_POOL'

export const SAVE_POOL_RESTAURANTS_REQUESTED = 'poolRestaurants/SAVE_POOL_RESTAURANTS_REQUESTED'
export const POOL_RESTAURANTS_SAVED = 'poolRestaurants/POOL_RESTAURANTS_SAVED'
export const SAVE_POOL_RESTAURANTS_ERROR = 'poolRestaurants/SAVE_POOL_RESTAURANTS_ERROR'

export const EDIT_POOL_RESTAURANTS_REQUESTED = 'poolRestaurants/EDIT_POOL_RESTAURANTS_REQUESTED'
export const EDIT_POOL_RESTAURANTS_DONE = 'poolRestaurants/EDIT_POOL_RESTAURANTS_DONE'

export const SEARCH_RESTAURANTS_FOR_POOL_REQUESTED = 'poolRestaurants/SEARCH_RESTAURANTS_FOR_POOL_REQUESTED'
export const RESTAURANTS_FOR_POOL_SEARCHED = 'poolRestaurants/RESTAURANTS_FOR_POOL_SEARCHED'
export const SEARCH_RESTAURANTS_FOR_POOL_ERROR = 'poolRestaurants/SEARCH_RESTAURANTS_FOR_POOL_ERROR'

export const loadRestaurantsAsync = (data) => {
  return dispatch => {
    dispatch({
      type: LOAD_POOL_RESTAURANTS_REQUESTED,
      id: data.id,
      user: data.user
    })

    PoolsApi.GetRestaurants(data.id, data.user)
      .then(response => {
        return response.json()
      })
      .then(json =>
        dispatch({
          type: LOAD_POOL_RESTAURANTS,
          data: json.restaurants || json, // next version of API will not wrap response into `restaurants`
          user: data.user
        }))
      .catch(function (error) {
        dispatch({
          type: LOAD_POOL_RESTAURANTS_ERROR,
          error: error.message
        })
        console.log('There has been a problem with your fetch operation: ', error)
      })
  }
}

export const removeFromPool = (data) => {
  return dispatch => {
    dispatch({
      type: REMOVE_RESTAURANT_FROM_POOL,
      restaurantId: data.restaurantId,
    })
  }
}

export const addToPool = (data) => {
  return dispatch => {
    dispatch({
      type: ADD_RESTAURANT_TO_POOL,
      restaurantId: data.restaurantId,
    })
  }
}

export const saveRestaurantsAsync = (poolId, restaurants) => {
  return dispatch => {
    dispatch({
      type: SAVE_POOL_RESTAURANTS_REQUESTED,
      poolId: poolId
    })

    const restaurantsRequest = {Restaurants : restaurants.map(r => r.id)}

    PoolsApi.SaveRestaurants(poolId, restaurantsRequest)
      .then(response => {
        if (response.ok) {
          dispatch({
            type: POOL_RESTAURANTS_SAVED,
            restaurants: restaurants,
            error: 'no error'
          })
          dispatch(addInfoNotification('Restaurants Saved'))
        }
        else {
          response.text()
            .then(text => {
              let error
              if (/application\/json/i.test(response.headers.get('Content-Type'))) {
                error = JSON.parse(text)['error'] || text
              } else {
                error = text
              }
              dispatch({
                type: SAVE_POOL_RESTAURANTS_ERROR,
                error: error
              })
              dispatch(addErrorNotification('Error saving restaurants', error))
            })
        }
      })
      .catch( error => {
        dispatch({
          type: SAVE_POOL_RESTAURANTS_ERROR,
          error: error.message
        })
        dispatch(addErrorNotification('Error saving restaurants', error.message))
        console.log('There has been a problem updating restaurants in pool: ', error)
      }).then(_ => PoolsApi.GetById(poolId))
        .then(response => response.json())
        .then(json =>  {
          if (json["isActive"] === false) {
            dispatch(addWarnNotification(`Pool ${json['name']} is inactive`))
          }
      });
  }
}

export const switchToEditMode = (restaurants) => {
  return dispatch => {
    dispatch({
      type: EDIT_POOL_RESTAURANTS_REQUESTED,
      restaurants: restaurants
    })
  }
}

export const switchToViewMode = () => {
  return dispatch => {
    dispatch({
      type: EDIT_POOL_RESTAURANTS_DONE
    })
  }
}


export const searchRestaurantsAsync = (restaurantFilter, offset) => {
  return dispatch => {
    dispatch({
      type: SEARCH_RESTAURANTS_FOR_POOL_REQUESTED,
      poolId: restaurantFilter
    })

    if (restaurantFilter.length < 3)
    {
      dispatch({
        type: RESTAURANTS_FOR_POOL_SEARCHED,
        foundRestaurants: null,
        error: 'no search done. filter too short'
      })
    }
    else{
      RestaurantsApi.SearchByName(restaurantFilter, offset)
        .then(response => {
          return response.json()
        })
        .then(json => {
          dispatch({
            type: RESTAURANTS_FOR_POOL_SEARCHED,
            foundRestaurants: json,
            error: 'no error'
          })
        })
        .catch(function (error) {
          dispatch({
            type: SEARCH_RESTAURANTS_FOR_POOL_ERROR,
            error: error.message
          })
          console.log('There has been a problem searching restaurants: ', error)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/poolRestaurants.js